import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import AbsenceResources from "../resources/AbsenceResources";
import LocationResources from "../resources/LocationResources";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'

function TeamAbsences({isLoggedIn, loggedInUser}){
  const [absences, setAbsences] = useState([])
  const [locations, setLocations] = useState([])
  const [selectedLocationId, setSelectedLocationId] = useState('all')

  const locationResources = new LocationResources()

    const loadAbsencesCurrentMonth = () => {
        let resources = new AbsenceResources()
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')

        return resources.post_filtered({
            start_date: startOfMonth,
            end_date: endOfMonth,
            location_id: selectedLocationId === 'all' ? null : Number(selectedLocationId)
        })
    }

    const loadLocations = () => {
        return locationResources.get()
    }

    const handleLocationChange = (locationId) => {
        setSelectedLocationId(locationId)
    }

    useEffect(() => {
        loadLocations().then(response => {
            setLocations(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadAbsencesCurrentMonth().then(response => {
            setAbsences(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    useEffect(() => {
        loadAbsencesCurrentMonth().then(response => {
            setAbsences(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, [selectedLocationId]);

    // Get all Sundays in current month
    const getSundaysInMonth = () => {
        const sundays = []
        const startOfMonth = moment().startOf('month')
        const endOfMonth = moment().endOf('month')
        let currentDate = startOfMonth.clone()

        // Find first Sunday
        while (currentDate.day() !== 0 && currentDate.isSameOrBefore(endOfMonth)) {
            currentDate.add(1, 'day')
        }

        // Get all Sundays
        while (currentDate.isSameOrBefore(endOfMonth)) {
            sundays.push(currentDate.clone())
            currentDate.add(7, 'days')
        }

        return sundays
    }

    // Get absences for a specific Sunday
    const getAbsencesForSunday = (sunday) => {
        return absences.filter(absence => {
            const absenceStart = moment(absence['start_date'])
            const absenceEnd = moment(absence['end_date'])
            return sunday.isBetween(absenceStart, absenceEnd, 'day', '[]')
        })
    }

    const sundays = getSundaysInMonth()

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                        {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Team Absences</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }

                        </div>
                    </div>
                </div>
            </div>

            <div id="main-container">
                {
                    isLoggedIn ?

                <div className="content">
                    <div className="container">
                        <div className="spacer-40"></div>

                        <div className="row">
                            <div className="col-md-12">
                                <h2 style={{color:"#ffa800"}}>
                                    <strong>{moment().format('MMMM YYYY')} Absences</strong>
                                </h2>
                            </div>
                        </div>

                        <div className="spacer-20"></div>

                        <div className="row">
                            <div className="col-md-12">
                                <div style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    marginBottom: '20px'
                                }}>
                                    <h4 style={{color: '#003165', marginBottom: '15px'}}>
                                        <strong>Filter by Location</strong>
                                    </h4>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '15px'}}>
                                        <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                                            <input
                                                type="radio"
                                                name="location"
                                                value="all"
                                                checked={selectedLocationId === 'all'}
                                                onChange={(e) => handleLocationChange(e.target.value)}
                                                style={{marginRight: '8px'}}
                                            />
                                            <span style={{color: '#003165', fontWeight: selectedLocationId === 'all' ? 'bold' : 'normal'}}>
                                                All Locations
                                            </span>
                                        </label>
                                        {locations.map((location) => (
                                            <label key={location.id} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                                                <input
                                                    type="radio"
                                                    name="location"
                                                    value={location.id.toString()}
                                                    checked={selectedLocationId === location.id.toString()}
                                                    onChange={(e) => handleLocationChange(e.target.value)}
                                                    style={{marginRight: '8px'}}
                                                />
                                                <span style={{color: '#003165', fontWeight: selectedLocationId === location.id.toString() ? 'bold' : 'normal'}}>
                                                    {location.name}
                                                </span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {sundays.map((sunday, index) => {
                            const sundayAbsences = getAbsencesForSunday(sunday)

                            if (sundayAbsences.length === 0) return null

                            return (
                                <div key={index} style={{marginBottom: '30px'}}>
                                    <h3 style={{color: '#ffa800', marginBottom: '15px'}}>
                                        <strong>{sunday.format('DD MMMM YYYY')} - Sunday</strong>
                                    </h3>

                                    <div style={{
                                        overflowX: 'auto',
                                        WebkitOverflowScrolling: 'touch',
                                        width: '100%'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            gap: '15px',
                                            paddingBottom: '10px'
                                        }}>
                                            {sundayAbsences.map((absence, absenceIndex) => (
                                                <div key={absenceIndex} style={{
                                                    minWidth: '200px',
                                                    backgroundColor: '#fff',
                                                    border: '2px solid #ffa800',
                                                    borderRadius: '10px',
                                                    padding: '15px',
                                                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                                                }}>
                                                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                                                        <img
                                                            src={absence['user.image']}
                                                            alt={`${absence['user.firstname']} ${absence['user.lastname']}`}
                                                            style={{
                                                                width: '80px',
                                                                height: '80px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '3px solid #003165'
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{textAlign: 'center'}}>
                                                        <div style={{
                                                            color: '#003165',
                                                            fontWeight: 'bold',
                                                            fontSize: '16px',
                                                            marginBottom: '5px'
                                                        }}>
                                                            {absence['user.firstname']} {absence['user.lastname']}
                                                        </div>
                                                        <div style={{
                                                            color: '#666',
                                                            fontSize: '13px',
                                                            marginBottom: '8px'
                                                        }}>
                                                            {absence['user.location.name']}
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '8px',
                                                            borderRadius: '5px',
                                                            fontSize: '12px'
                                                        }}>
                                                            <div style={{color: '#ffa800', fontWeight: 'bold', marginBottom: '3px'}}>
                                                                Absent Period:
                                                            </div>
                                                            <div style={{color: '#003165'}}>
                                                                {moment(absence['start_date']).format('DD MMM')} - {moment(absence['end_date']).format('DD MMM YYYY')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                        {sundays.every(sunday => getAbsencesForSunday(sunday).length === 0) && (
                            <div style={{
                                textAlign: 'center',
                                padding: '40px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '10px'
                            }}>
                                <p style={{color: '#666', fontSize: '18px'}}>
                                    No absences recorded for {moment().format('MMMM YYYY')}
                                </p>
                            </div>
                        )}

                    </div>
                </div> : <></>
        }
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };

};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamAbsences);
